package com.milta.core.localization.translations.es

import com.milta.core.localization.SubscriptionStrings

internal val Subscription = SubscriptionStrings(
    screenTitle = "Mi suscripción",
    screenSubtitle = "Gestiona tu suscripción Milta",
    planDriver = "Conductor",
    planOrganisation = "Empresa",
    statusActive = "Activa",
    statusTrial = "Prueba gratuita",
    statusExpired = "Expirada",
    statusCancelled = "Cancelada",
    platformLabel = "Plataforma",
    productIdLabel = "Producto",
    expiresAtLabel = "Expira el",
    noExpiry = "Sin fecha de expiración",
    noValue = "—",
    noSubscription = "Sin suscripción activa",
    activateButton = "Activar suscripción",
    successActivated = "Suscripción activada con éxito",
    perMonth = "/mes",
    pitchTitle = "Desbloquea todas las funciones de Milta",
    pitchSubtitle = "Elige la oferta adecuada para tu actividad para seguir entregando y gestionando tus rutas.",
    featuredBadge = "TODO INCLUIDO",
    driverFeature1 = "Rutas y entregas ilimitadas",
    driverFeature2 = "Prueba de entrega con foto + firma",
    driverFeature3 = "Notificaciones en tiempo real",
    orgFeature1 = "Gestión de equipo ilimitada",
    orgFeature2 = "Panel web completo",
    orgFeature3 = "Importación de rutas (Excel, PDF, foto)",
    orgFeature4 = "Acceso de Conductor incluido para ti",
    purchaseFinePrint = "Pago seguro a través de la tienda. Cancelable en cualquier momento desde los ajustes de la tienda.",
    purchasingLabel = "Procesando…",
    activeCaption = "Tu suscripción Milta",
    nextRenewalLabel = "Próxima renovación",
    includedTitle = "Incluido en tu oferta",
    manageOnGooglePlay = "Gestionar en Google Play",
    manageOnAppStore = "Gestionar en App Store",
    viewTechnicalDetails = "Ver detalles técnicos",
    monthNames = listOf("enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"),
    errorNotFound = "No se encontró ninguna suscripción activa",
    errorConflict = "Ya existe una suscripción activa para esta cuenta",
    errorPlanMismatch = "El plan seleccionado no coincide con el rol de tu cuenta",
    errorPlanRequired = "Selecciona un plan",
    errorPlanInvalid = "Plan seleccionado no válido",
    errorPlatformRequired = "La plataforma es obligatoria",
    errorPlatformInvalid = "Plataforma no válida. Debe ser AppStore o GooglePlay",
    errorStoreProductIdRequired = "El ID del producto de la tienda es obligatorio",
    errorReceiptTokenRequired = "El token del recibo es obligatorio",
    errorGeneric = "Se produjo un error. Por favor, inténtalo de nuevo.",
    trialBannerDaysPrefix = "🎉 Prueba gratuita: te quedan ",
    trialBannerDaysBold = "%d días",
    trialBannerDaysSuffix = " para descubrir Milta sin compromiso.",
    trialBannerHoursPrefix = "⏰ Tu prueba gratuita termina en ",
    trialBannerHoursBold = "%dh",
    trialBannerHoursSuffix = ": suscríbete para seguir usando Milta sin interrupciones.",
    coveredByEnterprise = "Cubierto por la suscripción de tu empresa",
    myEnterprisesTitle = "Mis empresas",
    enterpriseCoversYou = "Te cubre",
    enterpriseSubscriptionExpired = "Suscripción caducada",
    myEnterprisesFootnote = "Tus empresas optimizan las rutas que te envían con sus propios créditos. No ves su consumo.",
    takeDriverPlanForOwnUse = "Para optimizar tus propias rutas y usar la IA tú mismo, contrata una suscripción Conductor.",
    ownPlanNotNeededWhenCovered = "Tu empresa te cubre, así que tu suscripción personal no es necesaria. Te sirve para las optimizaciones que lanzas tú mismo.",
)
